import { Component, OnInit } from '@angular/core';
import { SideNavBarVisibilityService } from '../services/side-nav-bar-visibility.service';
import { ThemeService } from '../theme/theme-service.service';

@Component({
    selector: 'app-x-testing',
    templateUrl: './x-testing.component.html',
    styleUrls: ['./x-testing.component.scss'],
    standalone: false
})
export class XTestingComponent implements OnInit {
  constructor(
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    public themeService: ThemeService) { }

  ngOnInit(): void {
  }

}
